module.exports = "../images/stage-trout-forest-music-festival.jpg?v=eef5f73";